var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDrag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "12px",
    viewBox: "0 0 60 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowDrag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-7",
    transform: "translate(-158.000000, -94.000000)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.542515,94.0637083 L188,99.9251777 L215.457485,94.0637083 C216.593557,93.8211859 217.711129,94.5455513 217.953651,95.6816237 C217.984465,95.8259673 218,95.9731533 218,96.1207492 L218,96.1207492 C218,97.6463513 216.956091,98.9738547 215.473511,99.3336002 L188,106 L160.526489,99.3336002 C159.043909,98.9738547 158,97.6463513 158,96.1207492 L158,96.1207492 C158,94.9590791 158.94172,94.0173594 160.10339,94.0173594 C160.250986,94.0173594 160.398172,94.0328946 160.542515,94.0637083 Z",
    id: "arrowDrag"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDrag);
export default __webpack_public_path__ + "static/media/arrowDrag.2b343aba88daa1f866dd50ddf1339eff.svg";
export { ForwardRef as ReactComponent };